module.exports = __webpack_public_path__ + "img/develop_warehouse.7cfd2e9c.png";